/**
 * LocalStorage Service
 * wrapper around non-React window.localStorage API
 */
const LocalStorage = {
    /**
     * Checks if app is running in browser or server-side
     */
    runsInBrowser(): boolean {
        return typeof window !== 'undefined';
    },
    get(key: string): string | void {
        if (this.runsInBrowser()) {
            return localStorage.getItem(key);
        }
    },
    set(key: string, value: string): void {
        if (this.runsInBrowser()) {
            return localStorage.setItem(key, value);
        }
    },
    remove(key:string): void {
        if (this.runsInBrowser()) {
            return localStorage.removeItem(key);
        }
    }
};

export default LocalStorage;